import type { Expense } from '#/graphql/types';
import type { FormItem } from '#/common/components/Form';
import allFields from '#/modules/expense/utils/fields';
import { getHistorySection } from '#/common/utils/fields/historySection';

const fields: FormItem<Expense>[] = [
  {
    cssClass: 'tmm-section',
    caption: 'Expense Details',
    colCount: {
      xs: 1,
      sm: 1,
      md: 2,
      lg: 2,
    },
    items: [
      allFields.title,
      allFields.displayNumber,
      allFields.amount,
      allFields.workOrder,
      allFields.type,
      allFields.status,
      {
        ...allFields.description,
        colSpan: 2,
      },
    ],
  },
  getHistorySection(),
];

export default fields;
